import { getCloudinaryUrl, isEmpty } from "@swiggy-private/core-ui";
import { DEFAULT_IMG_ID, IMG_OPTIONS } from "@cart-ui/constants/SelfDeliveryInstruction";

export const getSelfDeliveryImgURL = (imgId: string): string => {
    if (isEmpty(imgId)) {
        return getCloudinaryUrl(DEFAULT_IMG_ID, IMG_OPTIONS);
    }
    return getCloudinaryUrl(imgId, IMG_OPTIONS);
};
